import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
    fields: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2.5),
    },
}));
